/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React, {CSSProperties} from 'react';
import {Loader} from "./loader";
import {ControlContext} from "../util/controlContext";

interface LoaderProps {
    label?: string,
    baseColor?: string,
    thickness: string,
    size: string,
    trackColor: string,
    containerClass: string,
    loaderClass: string,
    labelClass: string,
    active: boolean,
    disableBackground: boolean,
    loaderStyle: CSSProperties;
    position: 'absolute' | 'fixed' | 'relative';
}

export default class LoaderController extends React.Component<LoaderProps> {
    // noinspection JSUnusedGlobalSymbols
    declare context: React.ContextType<typeof ControlContext>;
    static contextType = ControlContext;

    static defaultProps = {
        trackColor: 'transparent',
        size: '5rem',
        thickness: '.2rem',
        containerClass: '',
        trackClass: '',
        loaderClass: '',
        labelClass: '',
        disableBackground: false,
        loaderStyle: {},
        position: 'absolute',
    };

    getBaseColor = () => {
        const {baseColor} = this.props;
        if (baseColor !== null && baseColor !== undefined) return baseColor;
        // noinspection JSDeprecatedSymbols
        return this.context.baseColor;
    };

    render = () => {
        const {
            active, trackColor, containerClass, loaderClass, labelClass, label, size, thickness, disableBackground,
            loaderStyle, position
        } = this.props;
        if (active)
            return <Loader baseColor={this.getBaseColor()} trackColor={trackColor} contextStyle={this.context}
                           containerClass={containerClass} loaderClass={loaderClass} labelClass={labelClass}
                           label={label} size={size} thickness={thickness} disableBackground={disableBackground}
                           loaderStyle={loaderStyle} position={position}/>;
        return null;
    }
}